import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { data } from '../../constants';
import { Headings } from '../../components';
import './Process.css';

const Process = () => {
  return (
    <section className="process section-padding" id="approach">
      <div className="site-container">
        <Headings title="How we engineer enterprise AI" text="A disciplined path from problem framing to governed product releases, built for teams that need AI to work reliably in production." />

        <Accordion defaultActiveKey="0">
          {data.WorkingProcess.map((item, index) => (
            <Accordion.Item eventKey={String(index)} key={index}>
              <Accordion.Header><div><span>{String(index + 1).padStart(2, '0')}</span> {item.title}</div></Accordion.Header>
              <Accordion.Body>
                <p>{item.description}</p>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </section>
  )
}

export default Process
